import React from "react";
import Hero from "../Hero/Hero";
import Skills from "../Skills/Skills";

const Home = () => {
  return (
    <div>
      <Hero />
      <Skills />
      
      
    </div>
  );
};

export default Home;
